import { z } from 'zod';
import { ExposedCompanyDTOSchema } from "./companies.dto.js";
export const FindAllCompaniesOutputDTOSchema = z.object({
    companies: z.array(ExposedCompanyDTOSchema),
    total: z.number(),
});
//# sourceMappingURL=find-all-companies.dto.js.map